const TOTAL_WIDTH = 12

export function getDefaultColumnWidth(numberOfColumns: number) {
    return TOTAL_WIDTH / numberOfColumns
}

export function getSmallColumnWidth(numberOfColumns: number) {
    return TOTAL_WIDTH / (numberOfColumns + 1)
}

export function getLargeColumnWidth(numberOfColumns: number) {
    return getSmallColumnWidth(numberOfColumns) * 2
}
